import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 450", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0,450H900V0H0z", fill: "#d62828" }), /* @__PURE__ */ React.createElement("path", { d: "M0,450V0H600z", fill: "#fcd856" }), /* @__PURE__ */ React.createElement("path", { d: "M0,450V0H300z", fill: "#003f87" }), /* @__PURE__ */ React.createElement("path", { d: "M0,450H900V150z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M0,450H900V300z", fill: "#007a3d" }));
const ForwardRef = forwardRef(SvgSc);
const Memo = memo(ForwardRef);
export default Memo;
